export const firebaseConfig = {
  apiKey: 'AIzaSyAj8e1ksFBsvA9OfleuyLBkuq1iOYqSkHw',
  authDomain: 'nftfolio-191fb.firebaseapp.com',
  projectId: 'nftfolio-191fb',
  storageBucket: 'nftfolio-191fb.appspot.com',
  messagingSenderId: '820599337273',
  appId: '1:820599337273:web:d59824fb9688e03618b8e8',
  measurementId: 'G-6BTQCDKGPD',
}
